export default "__VITE_ASSET__BhXC9_e4__"